import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { AgencyGuidanceListPage, parseGuidanceSearch, preferredGuidanceLanguage, rememberGuidanceLanguage } from '@/features/agency';
import type { GuidanceLanguage } from '@/features/agency';
import { formatDocumentTitle } from '@/lib/document-title';

/** Every agency member may read it: the parent layout gates the page, the API gates the content. */
export const Route = createFileRoute('/_auth/agency/guidance/')({
  validateSearch: parseGuidanceSearch,
  component: AgencyGuidanceRoute,
});

function AgencyGuidanceRoute() {
  const { lang } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const onLanguageChange = (next: GuidanceLanguage) => {
    rememberGuidanceLanguage(next);
    void navigate({ search: { lang: next }, replace: true });
  };
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Guidance')}</title>
      </Helmet>
      <AgencyGuidanceListPage language={lang ?? preferredGuidanceLanguage()} onLanguageChange={onLanguageChange} />
    </>
  );
}
